define([
	"dojo",
	"underscore"
], function(dojo, _) {

	var EMPTY_STRING = "",
		RE_NOT_WORD = new RegExp(/\W/);

	//function for debugging and tracing purposes
	//if called assigns a unique id on an object
	dojo.global.__csi_next_objid = 1;
	dojo.global.csi_objectId = function(obj) {
		if (!(obj instanceof Object)) return null;
		if (obj.__csi_obj_id == null) obj.__csi_obj_id = dojo.global.__csi_next_objid++;
		return obj.__csi_obj_id;
	};

	return {
		applyForEach: function(obj, f, scope) {
			var o;
			for (var i in obj) {
				o = obj[i];
				if ((o != null) && f.call(scope, o, i)) {
					return i;
				}
			}
			return null;
		},

		deepCopy: function(obj, fCallback) {
			// summary: Deep copy the object.
			// 'fCallback' is used to overwrite behavior of the deep copy.
			//
			// The signature of the callback is:
			//
			// function(anOwnerObject,propertyKey,fCallback)
			//		anOwnerObject - the owner object of the property to be copied
			//		propertyKey - the key of the property in 'anOwnerObject' to be copied
			//		fCallback - the reference to the callback function
			//
			// Example: copy an object except its 'customUrl' property
			//
			// function copyCallback(anOwnerObject,propertyKey,fCallback){
			//		if (propertyKey == 'customUrl')
			//			return undefined;
			//		else
			//			// otherwise, deep copy the property
			//			return csi.deepCopy(anOwnerObject[propertyKey],fCallback);
			// }
			var newObj = null;

			// Do not deep copy nulls, undefineds, number, strings and functions. Just reassign them
			if (obj == null || (typeof obj != "object")) {
				newObj = obj;
			} else if (typeof obj.clone === "function") {
				newObj = obj.clone();
			} else {
				// Call the constructor of the object to create a correct prototype.
				var aConstructor = obj.constructor;
				newObj = new aConstructor();

				// enumerate all properties and copy them
				if (fCallback) {
					for (var key in obj) {
						if (obj.hasOwnProperty(key))
							newObj[key] = fCallback(obj, key, fCallback);
					}
				} else {
					for (var key in obj) {
						if (obj.hasOwnProperty(key))
							newObj[key] = this.deepCopy(obj[key]);
					}
				}
			}

			return newObj;
		},

		/**
		 * Returns the property from an object given the bject and path to property
		 * @param {Object} object
		 * @param {string} propertyPath
		 * @returns {Any} localStorageObject
		 */
		getObjectProperty: function(object, propertyPath) {
			var pathParts = propertyPath.split(".");

			pathParts.forEach(function(part) {
				if (object && object.hasOwnProperty(part)) {
					object = object[part];
				} else {
					object = undefined;
				}
			});
			return object;
		},

		hashArray: function(/*Any[]*/a, /*String|Function?*/hash, /*String|Function?*/value, /*Object?*/o, /*Boolean*/bAllowMultiple) {
			// summary: hash elements of array into object given hash property or function - if no hash given,
			// then use string value as hash; objects that map to same key will overwrite one another unless bAllowMultiple is true
			// in which case keys will map to an array of values
			if (!a) return o;

			var h = hash;
			var v = value;

			o = o || {};

			if (typeof hash === "string") {
				h = function(x) {return x[hash];};
			} else if (hash === Number) {
				h = function(x, i) {return i;};
			} else if (!hash) {
				h = String;
			}

			if (typeof value === "string") {
				v = function(x, i) {return x[value];};
			} else if (value === Number) {
				v = function(x, i) {return i;};
			}

			if (bAllowMultiple) {
				_.each(a, function(x, i) {
					this.objectArrayAddValue(o, h(x, i), v ? v(x, i) : x);
				}, this);
			} else {
				_.each(a, function(x, i) {
					o[h(x, i)] = v ? v(x, i) : x;
				});
			}

			return o;
		},

		mergeObject: function(source, target, bRecursive, sOrigSuffix, bMergeArrays) {
			// NOTE: "source" could be modified as a result of this function
			// If 'sOrigSuffix' is not null, the original values will be preserved
			// with the key equals to the old key plus sOrigSuffix
			if (!bRecursive && (sOrigSuffix == null)) {
				// quick merge, overwriting if duplicates
				for (var i in source) {
					target[i] = source[i];
				}

				return target;
			}

			for (var i in source) {
				var t = target[i];
				var s = source[i];

				if (!t) {
					// add to target if not already there
					target[i] = s;
					if (sOrigSuffix != null)
						target[i + sOrigSuffix] = t;
				} else if (bRecursive && (typeof s !== "string") && (typeof t !== "string")) {
					// Recurse if both are objects.
					// when the source is an array and the target is an array and 'bMergeArrays' is true
					// then concatenate arrays
					// otherwise just overwrite the target
					if (s instanceof Array) {
						if (bMergeArrays && (t instanceof Array)) {
							target[i] = t.concat(s);
						} else {
							target[i] = s;
						}
					} else {
						this.mergeObject(s, t, bRecursive, sOrigSuffix, bMergeArrays);
					}
				} else if ((typeof s !== "string") && (typeof t === "string")) {
					// use source as new value, but with old target still as default value
					target[i] = s;

					if (s[EMPTY_STRING] == null)
						s[EMPTY_STRING] = t;

					// preserve the old target
					if (sOrigSuffix != null)
						s[sOrigSuffix] = t;
				} else {
					// overwrite target
					if ((typeof s === "string") && (typeof t !== "string")) {
						var oldValue = t[EMPTY_STRING];
						t[EMPTY_STRING] = s;

						// preserve the old target
						if (sOrigSuffix != null)
							t[sOrigSuffix] = oldValue;
					} else if (typeof t === "string") {
						// here 's' and 't' are both strings
						target[i] = s;

						// preserve the old target
						if (sOrigSuffix != null)
							target[i + sOrigSuffix] = t;
					} else {
						if (sOrigSuffix != null)
							this.mergeObject(s, t, false, sOrigSuffix);
						else
							target[i] = s;
					}
				}
			}

			return target;
		},

		objectEquals: function(/*Object*/obj1, /*Object*/obj2, /*Function?*/equals) {
			// summary: determine if objects have the same key-value pairs
			var i, x, y, n = 0;

			for (i in obj1) {
				x = obj1[i];
				y = obj2[i];

				if (x != y) {
					if (!equals) {
						return false;
					} else if ((x && !y) || (!x && y) || !equals(x, y)) {
						return false;
					}
				}

				++n;
			}

			for (i in obj2) {
				--n;
			}

			return !n;
		},

		objectNew: function(/*String*/key, /*String*/value) {
			// summary: create new object with given key-value pair - useful if "key" is a variable rather than hard-coded string
			var obj = {};
			obj[key] = value;
			return obj;
		},

		objectToString: function(/*Object*/obj, /*Number?*/n, /*String?*/newLineString, /*{n:String[]}?*/keyOrder) {
			var aLines = [];
			var bArray = obj instanceof Array;
			var data = bArray ? ["[", null, null, "]"] : ["{", null, null, "}"];
			var keys = bArray ? obj : (keyOrder ? keyOrder[n || 0] : null);
			var x, text;

			var newline = function() {
				var s = newLineString;

				for (var j = 0; j < n; ++j)
					s += "\t";

				return s;
			};

			var quoteString = function(s, bIfNotWord) {
				if (!bIfNotWord || s.match(RE_NOT_WORD)) {
					var quote = (s.indexOf('"') >= 0) ? "'" : '"';
					return quote + s + quote;
				}

				return s;
			};

			if (newLineString == null) {
				newLineString = "<br/>";
			}

			if (n) {
				++n;
			} else {
				n = 1;
			}

			try {
				_.each(keys || Object.keys(obj), function(key) {
					x = bArray ? key : obj[key];

					if (x != null) {
						if (typeof x === "string") {
							text = quoteString(x);
						} else if (typeof x === "object") {
							text = this.objectToString(x, n, newLineString, keyOrder);
						} else {
							text = x.toString();
						}

						aLines.push(bArray ? text : (quoteString(key) + ":" + text));
					}
				}, this);

				if (!keys) {
					aLines.sort();
				}

				text = newline() + aLines.join("," + newline());
			} catch (ex) {
				// just do the best you can - in some cases this is not supported
			}

			--n;
			data[1] = text;
			data[2] = newline();

			return data.join("");
		},

		/**
		 * Add a value for given key to the given object, returning a handle to remove it
		 * @deprecated Use addToGroupedObject instead
		 * @param {Record<string, any[]>} obj 
		 * @param {string} key 
		 * @param {any} value 
		 * @return {RemoveEventHandle}
		 */
		objectArrayAddValue(obj, key, value) {
			var a = obj[key];
			if (!a) {
				a = obj[key] = [];
			}

			a.push(value);

			const remove = () => {
				obj[key] = _.without(obj[key], value);
			};

			return {remove};
		},

		objectHasValue: function(obj, value) {
			for (var i in obj) {
				if (obj[i] == value)
					return true;
			}
			return false;
		},

		objectValues: function(obj) {
			var o, values = [];
			for (var i in obj) {
				o = obj[i];
				if (o != null) {
					values.push(o);
				}
			}
			return values;
		},

		objectRemoveValue: function(obj, value, bFirst) {
			var keys = [];

			for (var i in obj) {
				if (obj[i] == value) {
					delete obj[i];
					keys.push(i);

					if (bFirst) break;
				}
			}

			return keys;
		},

		objectNumberOfElements: function(obj) {
			var size = 0;
			for (var i in obj) {
				if (obj[i] != null) {
					++size;
				}
			}
			return size;
		}
	};
});